<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <!-- <v-card-title>
            Pkb List
            </v-card-title> -->
            <v-card-title>
              <v-btn
                color="primary"
                dark
                class="ma-2"
                @click="addData"
                v-if="role.create"
              >
                Add Pkb
              </v-btn>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('all');
                        }
                      "
                    >
                      All Record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :data="exportDisplayedPage"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('filter');
                        }
                      "
                    >
                      All filtered record
                    </downloadExcel>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="d-flex">
                <v-select
                  style=" max-width: 150px;"
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search = ''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                  class="ma-2"
                  single-line
                  hide-details
                >
                </v-text-field>
                <v-btn
                  :disabled="!search"
                  class="mt-5"
                  small
                  color="primary"
                  @click="searchButton"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  v-if="searchValue"
                  class="mt-5 ml-1"
                  dark
                  small
                  color="red"
                  @click="clearSearchButton"
                  >Clear</v-btn
                >
              </div>
            </v-card-title>

            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              :footer-props="{ 'items-per-page-options': [15, 30, 50, 100] }"
            >
              <template v-slot:[`header.pkb_status`]="{ header }">
                <v-select
                  style="font-size:10px;"
                  :items="optionStatus"
                  :label="header.text"
                  v-model="valueStatus"
                  @change="getList"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template>

              <template v-slot:[`item.detail`]="{ item }">
                <router-link
                  :to="{ name: 'Detail PKB', params: { id: item.id } }"
                  class="btn btn-primary"
                  >Detail
                </router-link>
              </template>
              <template v-slot:[`item.pkb_service_estimate_id`]="{ item }">
                <!-- <router-link
                  :to="{
                    name: 'Detail Service Estimate',
                    params: { id: item.pkb_service_estimate_id },
                  }"
                  class="btn btn-primary"
                  >{{ item.pkb_service_estimate.service_estimate_no }}
                </router-link> -->
                {{ item.pkb_service_estimate.service_estimate_no }}
              </template>

              <template v-slot:[`item.pkb_status`]="{ item }">
                <span v-if="item.pkb_status == 0">Registered</span>
                <span v-else-if="item.pkb_status == 1">Waiting service</span>
                <span v-else-if="item.pkb_status == 2"
                  >Service in-progress</span
                >
                <span v-else-if="item.pkb_status == 3">Waiting part</span>
                <span v-else-if="item.pkb_status == 5"
                  >Waiting cancel confirmation</span
                >
                <span v-else-if="item.pkb_status == 6">Canceled</span>
                <span v-else-if="item.pkb_status == 4 && !item.pkb_faktur && item.pkb_nota_part && !item.pkb_nota_service">Nota part created</span>
                <span v-else-if="item.pkb_status == 4 && !item.pkb_faktur && !item.pkb_nota_part && item.pkb_nota_service">Nota service created</span>
                <span v-else-if="item.pkb_status == 4 && !item.pkb_faktur && item.pkb_nota_part && item.pkb_nota_service">Nota service & part created</span>
                <span v-else-if="item.pkb_status == 4 && !item.pkb_faktur && !item.pkb_nota_service && !item.pkb_nota_part">Completed</span>
                <span v-else-if="item.pkb_status == 4 && item.pkb_faktur">Faktur created</span>

              </template>

              <template v-slot:[`header.pool`]="{ header }">
                  <v-select
                    style=" font-size:10px;"
                    :items="optionPool"
                    :label="header.text"
                    v-model="valuePool"
                    @change="getList"
                    item-text="text"
                    item-value="value"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                </template>
                <template v-slot:[`item.pool`]="{ item }">
    
                  <span >{{ item.pkb_service_estimate.pool.pool_name}} </span>
                    
                </template>

              <template
                v-slot:[`item.pkb_service_estimate.vehicles.vehicle_types`]="{
                  item,
                }"
              >
                <span v-if="item.pkb_service_estimate.vehicle_types">
                  {{
                    item.pkb_service_estimate.vehicle_types.vehicle_types
                      .vehicle_brands.vehicle_brand_name +
                      ", " +
                      item.pkb_service_estimate.vehicle_types.vehicle_types
                        .vehicle_model
                  }}
                </span>
              </template>
              <template
                v-slot:[`item.pkb_service_estimate.service_estimate_customer_plate_no`]="{
                  item,
                }"
              >
                <span v-if="item.pkb_service_estimate.vehicle_types && item.pkb_service_estimate.service_estimate_type == 1">
                  {{ item.pkb_service_estimate.vehicle_types.vehicle_plate_no }}
                </span>
                <span v-if="item.pkb_service_estimate.vehicle_types && item.pkb_service_estimate.service_estimate_type == 2">
                  {{ item.pkb_service_estimate.vehicle_types.vehicle_plate_no }}
                </span>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="detailPkb(item.id)">
                      <v-list-item-title x-small>Detail</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="item.pkb_status != 4 && role.update"
                      @click="editPkb(item.id)"
                    >
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="item.pkb_status == 0 && role.delete"
                      @click="deleteConfirmation(item.id)"
                    >
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        !item.pkb_nota_part &&
                          item.pkb_status == 4 &&
                          item.pkb_part.length != 0
                      "
                      @click="createNotaPart(item.id)"
                    >
                      <v-list-item-title>Create Nota Part</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        !item.pkb_nota_service &&
                          item.pkb_status == 4 &&
                          item.pkb_service.length != 0
                      "
                      @click="createNotaJasa(item.id, item.pkb_no)"
                    >
                      <v-list-item-title>Create Nota Jasa</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        !item.pkb_faktur &&
                          item.pkb_nota_service &&
                          ((item.pkb_part.length != 0 && item.pkb_nota_part) ||
                            item.pkb_part.length == 0)
                      "
                      @click="createFaktur(item.id)"
                    >
                      <v-list-item-title>Create Faktur</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.pkb_nota_part!=null" @click="showNotaPart(item.pkb_nota_part.id)">
                      <v-list-item-title >View Nota Part</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.pkb_nota_service!=null" @click="showNotaJasa(item.pkb_nota_service.id)">
                      <v-list-item-title >View Nota Jasa</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.pkb_faktur!=null" @click="showFaktur(item.pkb_faktur.id)">
                      <v-list-item-title >View Faktur</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
    <modal ref="modalAddPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>ADD PKB</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAdd()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-pkb />
      </template>
    </modal>
    <modal ref="modalEditPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>EDIT PKB</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseEdit()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <edit-pkb :data_id="$refs.modalEditPage.data" />
      </template>
    </modal>
    <modal ref="modalCreateNotaPartPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>CREATE NOTA PART</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseCreateNotaPart()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <create-nota-part :data_id="$refs.modalCreateNotaPartPage.data" />
      </template>
    </modal>
    <modal ref="modalCreateNotaJasaPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>CREATE NOTA JASA</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseCreateNotaJasa()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <create-nota-jasa :data_id="$refs.modalCreateNotaJasaPage.data" />
      </template>
    </modal>
    <modal ref="modalCreateFakturPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>CREATE FAKTUR</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseCreateFaktur()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <create-faktur :data_id="$refs.modalCreateFakturPage.data" />
      </template>
    </modal>
    <modal ref="modalDetailPage">
    <template v-slot:body >
      <detail-pkb :data_id="$refs.modalDetailPage.data" />
    </template>
  </modal>
  <modal ref="modalShowNotaPartPage">
    <template v-slot:body >
      <detail-nota-part :data_id="$refs.modalShowNotaPartPage.data" />
    </template>
  </modal>
  <modal ref="modalShowNotaJasaPage">
    <template v-slot:body >
      <detail-nota-jasa :data_id="$refs.modalShowNotaJasaPage.data" />
    </template>
  </modal>
  <modal ref="modalShowFakturPage">
    <template v-slot:body >
      <detail-faktur :data_id="$refs.modalShowFakturPage.data" />
    </template>
  </modal>
  </div>
</template>

<script>
import vuetify from "@/plugins/vuetify";
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";
import { Modal } from "@/components";
import AddPKB from "@/pages/Dashboard/Workshop/PKB/AddPKBPage.vue";
import EditPKB from "@/pages/Dashboard/Workshop/PKB/EditPKBPage.vue";
import DetailPKB from "@/pages/Dashboard/Workshop/PKB/DetailPKBPage.vue";
import CreateNotaPart from "@/pages/Dashboard/Workshop/NotaPart/AddNPPage.vue";
import CreateNotaJasa from "@/pages/Dashboard/Workshop/NotaJasaBkl/AddNJBPage.vue";
import DetailNotaPart from "@/pages/Dashboard/Workshop/NotaPart/DetailNPPage.vue";
import DetailNotaJasa from "@/pages/Dashboard/Workshop/NotaJasaBkl/DetailNJBPage.vue";
import DetailFaktur from "@/pages/Dashboard/Workshop/Faktur/DetailFaktur.vue";
import Swal from 'sweetalert2';
import CreateFaktur from "@/pages/Dashboard/Workshop/Faktur/AddFakturPage.vue";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage, Modal, "add-pkb" : AddPKB
    , "edit-pkb" : EditPKB, "detail-pkb" : DetailPKB, "create-nota-part" : CreateNotaPart, "create-nota-jasa" : CreateNotaJasa
    , "create-faktur" : CreateFaktur, "detail-nota-part" : DetailNotaPart, "detail-nota-jasa" : DetailNotaJasa, "detail-faktur" : DetailFaktur
  },
  vuetify,
  data() {
    return {
      user: null,
      searchValue: null,
      searchCategory: null,
      option_filter: [
        { text: "PKB No.", value: "pkb_no" },
        { text: "PKB Date", value: "pkb_datetime" },
        { text: "Plat No", value: "pkb_plat_no" },
        { text: "Service Estimate No", value: "service_estimate_no" },
        { text: "Teknisi", value: "pkb_teknisi" },
      ],
      optionStatus: [
        { text: "All", value: "" },
        { text: "Registered", value: "registered" },
        { text: "Waiting service", value: "waiting_service" },
        { text: "Service in-progress", value: "service_in_progress" },
        { text: "Waiting part", value: "waiting_part" },
        { text: "Completed", value: "completed" },
        {
          text: "Waiting cancel confirmation",
          value: "waiting_cancel_confirmation",
        },
        { text: "Nota service created", value: "nota_service_created" },
        { text: "Nota part created", value: "nota_part_created" },
        { text: "Faktur created", value: "faktur_created" },

      ],
      page: 1,
      totalDataTable: 0,
      numberOfPages: 0,
      loadTable: true,
      role: "",
      search: "",
      valueStatus: "",
      options: {},
      headers: [
        // {
        //   text: 'Detail',
        //   align: 'start center',
        //   value: 'detail',
        //   sortable: false
        // },
        {
          text: "Actions",
          align: "start center",
          value: "actions",
          sortable: false,
        },
        { text: "Status", value: "pkb_status", sortable: false , width:'100'},
        { text: "PKB No.", value: "pkb_no" },
        { text: "PKB Date", value: "pkb_datetime", width:'150' },
        { text: "Service Estimate No.", value: "pkb_service_estimate_id", width:'150' },
        {
          text: "Customer Name",
          value: "pkb_service_estimate.client.client_name", width:'300'
        },
        {
          text: "Plate No.",
          value: "pkb_service_estimate.service_estimate_customer_plate_no",
        },
        {
          text: "Merk/Type",
          value: "pkb_service_estimate.vehicles.vehicle_types", width:'250'
        },
        { text: "Repeat Order", value: "pkb_repeat_order" },
        { text: "Teknisi", value: "pkb_teknisi_name.name", width:'150' },
        { text: "Work Order Type", value: "pkb_work_order_type" },
        { text: "Created At", value: "created_at", align: "center", width:'200' },
      ],
      table: [],
      worksheetName: "PKB",
      fileName: "PKB.xls",
      exportDisplayedPage: [],
      exportAllFitered: [],
      exportAll: [],
      field_export: {
        no: "no",
        "PKB No": "pkb_no",
        "Create Datetime": "pkb_datetime",
        "Eshed": "pkb_pool",
        "PKB Status": "pkb_status",
        "PPN/NO PPN": "service_estimate_ppn",
        "PKB Repeat Order": "pkb_repeat_order",
        "Keluhan": "pkb_keluhan",
        "Analisa": "pkb_analisa",
        "Catatan": "pkb_catatan",
        "Perintah Kerja": "pkb_perintah_kerja",
        "Teknisi": "pkb_teknisi",
        "Payment Plan": "pkb_payment_plan",
        "Work Oder Type": "pkb_work_order_type",
        "No Service": "no_service",
        "Service Name": "service_estimate_service_name",
        "Service Code": "service_estimate_service_code",
        "Service Lts": "service_estimate_service_lts",
        "Service Price": "service_estimate_service_price",
        "Service Total": "service_estimate_service_total",
        "Service Remark": "service_estimate_service_remark",
        "No Part": "no_part",
        "Part Name": "service_estimate_part_name",
        "Part Code": "service_estimate_part_code",
        "Part Price": "service_estimate_part_price",
        "Part Qty": "service_estimate_part_qty",
        "Part Total": "service_estimate_part_total",
        "Part Remark": "service_estimate_part_remark",
        "Service Estimate No": "service_estimate_no",
        "Guarantee/Not Guarantee": "service_estimate_guarantee",
        "Client Phone": "client_phone",
        "Client Name": "client_name",
        "Client Email": "client_email",
        "Client Address": "client_address",
        "Plate No": "vehicle_plate_no",
        "Vehicle No": "vehicle_door_no",
        "Vehicle Model": "vehicle_model_car",
        "Vehicle Body Color": "vehicle_body_color",
        "Fuel Type": "vehicle_fuel_type",
        "Vehicle KM": "vehicle_km",
        "Vehicle Production Year": "vehicle_production_year",
        "Chassis No": "vehicle_chasis_no",
        "Engine No": "vehicle_engine_no",
        
        "Spion": "pkb_spion",
        "Battery 1": "pkb_battery_1",
        "Battery 2": "pkb_battery_2",
        "Rak Depan": "pkb_rak_depan",
        "Rak Belakang": "pkb_rak_belakang",
        "Created At": "created_at",
        "Updated At": "updated_at",
      },
      
      optionPool: [
            { text: "All", value: "" },
          ],
          valuePool: "",
    };
  },
  watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    console.log(this.$route);
     //set refs in root saat page terbuka, agar fungsi di page ini bisa di panggil dari page lain
      this.$root.$refs.ListPkbPage = this;
      //check saat page terbuka apakah ada params 
      if(this.$route.params.id){
       
        //open detail
        this.detailPkb(this.$route.params.id)
      }
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];

    this.user = await this.$store.getters["profile/me"];
      if(!this.user.pool){
        this.headers.push({ text: "Eshed", value: "pool", sortable: false, width:'120' });
        await this.$store.dispatch("workshop_pool/list");
        await this.$store.getters["workshop_pool/list"].forEach((value, index) => {
          this.optionPool.push({ text: value.pool_name, value:  value.id});
         });
      }
    this.getList();
    this.mounted = false;
  },
  methods: {
    // ambil data yang dibutuhkan
    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      var query = { page: { number: pageNumber, size: itemsPerPage } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

      if (this.valueStatus != "") {
        if (query.filter) {
          Object.assign(query.filter, { pkb_status: this.valueStatus });
        } else {
          query.filter = { pkb_status: this.valueStatus };
        }
      }

      if(this.valuePool!=''){
        if(query.filter){
          Object.assign(query.filter, {pkb_pool:this.valuePool});
        }
        else{
          query.filter = {pkb_pool:this.valuePool}
        }
      }
    

      await this.$store.dispatch("workshop_pkb/list", query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
      this.table = await this.$store.getters["workshop_pkb/list"];
      var pageMeta = await this.$store.getters["workshop_pkb/page"];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta);
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },
    searchButton() {
      this.options.page = 1;
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.options.page = 1;
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
      // if(this.$refs.vTable){
      //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
      // }
      // else{
      //   this.exportAllFitered = this.dataExport(this.table)
      // }
    },

    //fungsi konfirmasi delete
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deletePkb(id);
        }
      });
    },
    //fungsi delete
    async deletePkb(id) {
      try {
        //kirim data keserver
        await this.$store.dispatch("workshop_pkb/destroy", id);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "User data delete successfully."
        );
        //jalankan fungsi kembali kelist
        this.getList();
        //await this.getList();
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },

    async dataExportBefore(type) {
      if (this.table.length != 0) {
        console.log("ewww");
        if (type == "all") {
          await this.$store.dispatch("workshop_pkb/list");
          return this.dataExport(
            await this.$store.getters["workshop_pkb/list"]
          );
        } else if (type == "filter") {
          var query = {};

          if (this.searchValue && this.searchCategory) {
            if (query.filter) {
              Object.assign(query.filter, {
                [this.searchCategory]: this.searchValue,
              });
            } else {
              query.filter = { [this.searchCategory]: this.searchValue };
            }
          }

          await this.$store.dispatch("workshop_pkb/list", query);
          return this.dataExport(
            await this.$store.getters["workshop_pkb/list"]
          );
        }
      }
    },

    // fungsi tombol direct ke add page
    // addData() {
    //   // panggil add page
    //  this.$router.push({name: 'Add PKB'});
    // },
    addData() {
      this.$refs.modalAddPage.openModal();
    },
    modalCloseAdd() {
      this.$refs.modalAddPage.closeModal();
      this.getList();
    },

    editPkb(id) {
      this.$refs.modalEditPage.openModal({ id: id });
    },
    modalCloseEdit() {
      this.$refs.modalEditPage.closeModal();
      this.getList();
    },

    createNotaPart(id) {
      this.$refs.modalCreateNotaPartPage.openModal({ id: id });
    },
    modalCloseCreateNotaPart() {
      this.$refs.modalCreateNotaPartPage.closeModal();
      this.getList();
    },

    showNotaPart(id){
      this.$refs.modalShowNotaPartPage.openModal({id:id, mode:"pkb"})

    },
    modalCloseShowNotaPart(){
      this.$refs.modalShowNotaPartPage.closeModal();

    },

    createNotaJasa(id){
      this.$refs.modalCreateNotaJasaPage.openModal({id:id})
    },
    modalCloseCreateNotaJasa() {
      this.$refs.modalCreateNotaJasaPage.closeModal();
      this.getList();
    },

    showNotaJasa(id){
      this.$refs.modalShowNotaJasaPage.openModal({id:id, mode:"pkb"})

    },
    modalCloseshowNotaJasa(){
      this.$refs.modalShowNotaJasaPage.closeModal();

    },

    showFaktur(id){
      this.$refs.modalShowFakturPage.openModal({id:id, mode:"pkb"})

    },
    modalCloseshowFaktur(){
      this.$refs.modalShowFakturPage.closeModal();

    },

    createFaktur(id){
      this.$refs.modalCreateFakturPage.openModal({id:id})
    },
    modalCloseCreateFaktur() {
      this.$refs.modalCreateFakturPage.closeModal();
      this.getList();
    },

    detailPkb(id) {
      this.$refs.modalDetailPage.openModal({ id: id });
    },
    modalCloseDetail() {
      this.$refs.modalDetailPage.closeModal();
      this.getList();
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    dataExport(data) {
      var dataReturn = [];
      data.forEach((value_1, index_1) => {
        // console.log(value_1)
        var client_phone = null;
        var client_name = null;
        var client_email = null;
        var client_address = null;
        var pkb_status = null;

        if (value_1.pkb_status == 0) {
          pkb_status = "registered";
        } else if (value_1.pkb_status == 1) {
          pkb_status = " waiting service";
        } else if (value_1.pkb_status == 2) {
          pkb_status = "service in-progress";
        } else if (value_1.pkb_status == 3) {
          pkb_status = "waiting payment";
        } else if (value_1.pkb_status == 4) {
          pkb_status = "completed";
        }
        if (value_1.pkb_service_estimate.client) {
          client_phone = value_1.pkb_service_estimate.client.client_phone;
          client_name = value_1.pkb_service_estimate.client.client_name;
          client_email = value_1.pkb_service_estimate.client.client_email;
          client_address = value_1.pkb_service_estimate.client.client_address;
        }
        var service_estimate_ppn = "";
        if (value_1.pkb_service_estimate.service_estimate_ppn == 0) {
          service_estimate_ppn = "yes";
        }
        if (value_1.pkb_service_estimate.service_estimate_ppn == 1) {
          service_estimate_ppn = "no";
        }
        var service_estimate_guarantee = "";
        if (value_1.pkb_service_estimate.service_estimate_guarantee == 1) {
          service_estimate_guarantee = "yes";
        }

        var keluhan = "";
        var analisa = "";
        if (value_1.pkb_service_estimate.keluhan) {
          for (var key in value_1.pkb_service_estimate
            .keluhan) {
            if (key == 0) {
              keluhan =
                key +
                1 +
                ". " +
                value_1.pkb_service_estimate.keluhan[key]
                  .keluhan;
              analisa =
                key +
                1 +
                ". " +
                value_1.pkb_service_estimate.keluhan[key]
                  .analisa;
            } else {
              keluhan =
                keluhan +
                ", " +
                key +
                1 +
                ". " +
                value_1.pkb_service_estimate.keluhan[key]
                  .keluhan;
              analisa =
                analisa +
                ", " +
                key +
                1 +
                ". " +
                value_1.pkb_service_estimate.keluhan[key]
                  .analisa;
            }
          }
        }
        var vehicle_model = null;
        var vehicle_plate_no = null;
        var vehicle_production_year = null;
        var vehicle_chassis_no = null;
        var vehicle_engine_no = null;
        var vehicle_door_no = null;
        var vehicle_body_color = null;
        var vehicle_fuel_type = null; 
        if (value_1.pkb_service_estimate.vehicle_types) {
          vehicle_plate_no =
            value_1.pkb_service_estimate.vehicle_types.vehicle_plate_no;
          vehicle_production_year =
            value_1.pkb_service_estimate.vehicle_types.vehicle_production_year;
          vehicle_chassis_no =
            value_1.pkb_service_estimate.vehicle_types.vehicle_chassis_no;
          vehicle_engine_no =
            value_1.pkb_service_estimate.vehicle_types.vehicle_engine_no;
          vehicle_door_no =
            value_1.pkb_service_estimate.vehicle_types.vehicle_door_no;
          if(value_1.pkb_service_estimate.service_estimate_type == 1){
            if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 0
              ) {
                vehicle_body_color = "Putih";
              } else if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 1
              ) {
                vehicle_body_color = "Putih Kuning";
              } else if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 2
              ) {
                vehicle_body_color = "Putih Metalik";
              } else if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 3
              ) {
                vehicle_body_color = "Hitam";
              } else if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 4
              ) {
                vehicle_body_color = "Hitam Metalik";
              } else if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 5
              ) {
                vehicle_body_color = "Silver";
              } else if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 6
              ) {
                vehicle_body_color = "Silver Metalik";
              } else if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 7
              ) {
                vehicle_body_color = "Abu Abu";
              } else if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 8
              ) {
                vehicle_body_color = "Abu Abu Metalik";
              } else if (
                value_1.pkb_service_estimate.vehicle_types.vehicle_body_color == 9
              ) {
                vehicle_body_color = "Hijau";
              }
          }
         else if(value_1.pkb_service_estimate.service_estimate_type == 2){
            vehicle_body_color = value_1.pkb_service_estimate.vehicle_types.vehicle_body_color;
          }
          if (value_1.pkb_service_estimate.vehicle_types) {
            vehicle_model =
              value_1.pkb_service_estimate.vehicle_types.vehicle_types
                .vehicle_brands.vehicle_brand_name +
              ", " +
              value_1.pkb_service_estimate.vehicle_types.vehicle_types
                .vehicle_model +
              " " +
              value_1.pkb_service_estimate.vehicle_types.vehicle_types
                .vehicle_year_model;
          }
          if (
            value_1.pkb_service_estimate.vehicle_types.vehicle_types
              .vehicle_fuel_type == 1
          ) {
            vehicle_fuel_type = "Bensin";
          } else if (
            value_1.pkb_service_estimate.vehicle_types.vehicle_types
              .vehicle_fuel_type == 2
          ) {
            vehicle_fuel_type = "Diesel";
          } else if (
            value_1.pkb_service_estimate.vehicle_types.vehicle_types
              .vehicle_fuel_type == 3
          ) {
            vehicle_fuel_type = "Listrik";
          } else if (
            value_1.pkb_service_estimate.vehicle_types.vehicle_types
              .vehicle_fuel_type == 4
          ) {
            vehicle_fuel_type = "Hybrid";
          } else if (
            value_1.pkb_service_estimate.vehicle_types.vehicle_types
              .vehicle_fuel_type == 5
          ) {
            vehicle_fuel_type = "CNG";
          } 
        }

        value_1.pkb_service_estimate.service_estimate_customer_plate_no;
        if (value_1.pkb_service.length != 0 || value_1.pkb_part.length != 0) {
          if (value_1.pkb_service.length >= value_1.pkb_part.length) {
            value_1.pkb_service.forEach((value_2, index_2) => {
              //this.dataExsport.push
              if (value_1.pkb_part[index_2]) {
                // console.log(index_1+", "+value_1.service_estimate_no+" service "+value_2.service_category_name+' - '+value_1.service_estimate_part[index_2].id)
                var no = null;
                if (index_2 == 0) {
                  no = index_1 + 1;
                }
                var data = {
                  no: no,
                  pkb_no: value_1.pkb_no,
                  pkb_datetime: value_1.pkb_datetime,
                  pkb_pool: value_1.pkb_service_estimate.pool.pool_name,
                  pkb_status: pkb_status,
                  service_estimate_no:
                    value_1.pkb_service_estimate.service_estimate_no,
                  service_estimate_create_at_datetime:
                    value_1.pkb_service_estimate
                      .service_estimate_create_at_datetime,
                  service_estimate_ppn: service_estimate_ppn,
                  service_estimate_guarantee: service_estimate_guarantee,
                  client_phone: client_phone,
                  client_name: client_name,
                  client_email: client_email,
                  client_address: client_address,
                  vehicle_plate_no: vehicle_plate_no,
                  vehicle_door_no: vehicle_door_no,
                  vehicle_model_car: vehicle_model,
                  vehicle_body_color: vehicle_body_color,
                  vehicle_production_year: vehicle_production_year,
                  vehicle_chasis_no: vehicle_chassis_no,
                  vehicle_engine_no: vehicle_engine_no,
                  vehicle_fuel_type: vehicle_fuel_type,
                  vehicle_km: value_1.pkb_service_estimate.service_estimate_vehicle_km,
                  

                  pkb_spion: value_1.pkb_spion == 1 ? "Yes" : "no",
                  pkb_battery_1: value_1.pkb_battery_1 == 1 ? "Yes" : "no",
                  pkb_battery_2: value_1.pkb_battery_2 == 1 ? "Yes" : "no",
                  pkb_rak_depan: value_1.pkb_rak_depan == 1 ? "Yes" : "no",
                  pkb_rak_belakang: value_1.pkb_rak_belakang == 1 ? "Yes" : "no",
                  
                  pkb_repeat_order: value_1.pkb_repeat_order,
                  pkb_keluhan: keluhan,
                  pkb_analisa: analisa,
                  pkb_catatan: value_1.pkb_catatan,
                  pkb_perintah_kerja: value_1.pkb_perintah_kerja,
                  pkb_teknisi: value_1.pkb_teknisi,
                  pkb_payment_plan: value_1.pkb_payment_plan,
                  pkb_work_order_type: value_1.pkb_work_order_type,
                  no_service: index_2 + 1,
                  service_estimate_service_name: value_2.service_master_name,
                  service_estimate_service_code: value_2.service_master_code,
                  service_estimate_service_lts: value_2.service_master_lts,
                  service_estimate_service_price:
                    value_2.service_category_standard_cost,
                  service_estimate_service_total: Math.round(
                    value_2.service_master_lts *
                      value_2.service_category_standard_cost
                  ),
                  service_estimate_service_remark: value_2.pkb_service_remark,
                  no_part: index_2 + 1,
                  service_estimate_part_name:
                    value_1.pkb_part[index_2].spare_part_master_name,
                  service_estimate_part_code:
                    value_1.pkb_part[index_2].spare_part_master_code,
                  service_estimate_part_price:
                    value_1.pkb_part[index_2].spare_part_master_unit_price,
                  service_estimate_part_qty:
                    value_1.pkb_part[index_2].pkb_spare_part_qty,
                  service_estimate_part_total:
                    value_1.pkb_part[index_2].pkb_spare_part_qty *
                    value_1.pkb_part[index_2].spare_part_master_unit_price,
                  service_estimate_part_remark:
                    value_1.pkb_part[index_2].pkb_spare_part_remark,
                  created_at: value_1.created_at,
                  updated_at: value_1.updated_at,
                };
                dataReturn.push(data);
              } else {
                // console.log(index_1+", "+value_1.service_estimate_no+" service "+value_2.service_category_name+' - kosong')
                var no = null;
                if (index_2 == 0) {
                  no = index_1 + 1;
                }
                var data = {
                  no: no,
                  pkb_no: value_1.pkb_no,
                  pkb_datetime: value_1.pkb_datetime,
                  pkb_pool: value_1.pkb_service_estimate.pool.pool_name,
                  pkb_status: pkb_status,
                  service_estimate_no:
                    value_1.pkb_service_estimate.service_estimate_no,
                  service_estimate_create_at_datetime:
                    value_1.pkb_service_estimate
                      .service_estimate_create_at_datetime,
                  service_estimate_ppn: service_estimate_ppn,
                  service_estimate_guarantee: service_estimate_guarantee,
                  client_phone: client_phone,
                  client_name: client_name,
                  client_email: client_email,
                  client_address: client_address,
                  vehicle_plate_no: vehicle_plate_no,
                  vehicle_door_no: vehicle_door_no,
                  vehicle_model_car: vehicle_model,
                  vehicle_body_color: vehicle_body_color,
                  vehicle_production_year: vehicle_production_year,
                  vehicle_chasis_no: vehicle_chassis_no,
                  vehicle_engine_no: vehicle_engine_no,
                  vehicle_fuel_type: vehicle_fuel_type,
                  vehicle_km: value_1.pkb_service_estimate.service_estimate_vehicle_km,

                  pkb_spion: value_1.pkb_spion == 1 ? "Yes" : "no",
                  pkb_battery_1: value_1.pkb_battery_1 == 1 ? "Yes" : "no",
                  pkb_battery_2: value_1.pkb_battery_2 == 1 ? "Yes" : "no",
                  pkb_rak_depan: value_1.pkb_rak_depan == 1 ? "Yes" : "no",
                  pkb_rak_belakang: value_1.pkb_rak_belakang == 1 ? "Yes" : "no",

                  
                  pkb_repeat_order: value_1.pkb_repeat_order,
                  pkb_keluhan: keluhan,
                  pkb_analisa: analisa,
                  pkb_catatan: value_1.pkb_catatan,
                  pkb_perintah_kerja: value_1.pkb_perintah_kerja,
                  pkb_teknisi: value_1.pkb_teknisi,
                  pkb_payment_plan: value_1.pkb_payment_plan,
                  pkb_work_order_type: value_1.pkb_work_order_type,
                  no_service: index_2 + 1,
                  service_estimate_service_name: value_2.service_master_name,
                  service_estimate_service_code: value_2.service_master_code,
                  service_estimate_service_lts: value_2.service_master_lts,
                  service_estimate_service_price:
                    value_2.service_category_standard_cost,
                  service_estimate_service_total:
                    parseFloat(value_2.service_master_lts) *
                    value_2.service_category_standard_cost,
                  service_estimate_service_remark: value_2.pkb_service_remark,
                  no_part: null,
                  service_estimate_part_name: null,
                  service_estimate_part_code: null,
                  service_estimate_part_price: null,
                  service_estimate_part_qty: null,
                  service_estimate_part_total: null,
                  service_estimate_part_remark: null,
                  created_at: value_1.created_at,
                  updated_at: value_1.updated_at,
                };
                dataReturn.push(data);
              }
            });
          } else {
            value_1.pkb_part.forEach((value_2, index_2) => {
              if (value_1.pkb_service[index_2]) {
                // console.log(index_1+", "+value_1.service_estimate_no+" part "+value_2.spare_part_master_name+' - '+value_1.service_estimate_service[index_2].id)
                var no = null;
                if (index_2 == 0) {
                  no = index_1 + 1;
                }
                var data = {
                  no: no,
                  pkb_no: value_1.pkb_no,
                  pkb_datetime: value_1.pkb_datetime,
                  pkb_pool: value_1.pkb_service_estimate.pool.pool_name,
                  pkb_status: pkb_status,
                  service_estimate_no:
                    value_1.pkb_service_estimate.service_estimate_no,
                  service_estimate_create_at_datetime:
                    value_1.pkb_service_estimate
                      .service_estimate_create_at_datetime,
                  service_estimate_ppn: service_estimate_ppn,
                  service_estimate_guarantee: service_estimate_guarantee,
                  client_phone: client_phone,
                  client_name: client_name,
                  client_email: client_email,
                  client_address: client_address,
                  vehicle_plate_no: vehicle_plate_no,
                  vehicle_door_no: vehicle_door_no,
                  vehicle_model_car: vehicle_model,
                  vehicle_body_color: vehicle_body_color,
                  vehicle_production_year: vehicle_production_year,
                  vehicle_chasis_no: vehicle_chassis_no,
                  vehicle_engine_no: vehicle_engine_no,
                  vehicle_fuel_type: vehicle_fuel_type,
                  vehicle_km: value_1.pkb_service_estimate.service_estimate_vehicle_km,
                  
                  pkb_spion: value_1.pkb_spion == 1 ? "Yes" : "no",
                  pkb_battery_1: value_1.pkb_battery_1 == 1 ? "Yes" : "no",
                  pkb_battery_2: value_1.pkb_battery_2 == 1 ? "Yes" : "no",
                  pkb_rak_depan: value_1.pkb_rak_depan == 1 ? "Yes" : "no",
                  pkb_rak_belakang: value_1.pkb_rak_belakang == 1 ? "Yes" : "no",

                  
                  pkb_repeat_order: value_1.pkb_repeat_order,
                  pkb_keluhan: keluhan,
                  pkb_analisa: analisa,
                  pkb_catatan: value_1.pkb_catatan,
                  pkb_perintah_kerja: value_1.pkb_perintah_kerja,
                  pkb_teknisi: value_1.pkb_teknisi,
                  pkb_payment_plan: value_1.pkb_payment_plan,
                  pkb_work_order_type: value_1.pkb_work_order_type,
                  no_service: index_2 + 1,
                  service_estimate_service_name:
                    value_1.pkb_service[index_2].service_master_name,
                  service_estimate_service_code:
                    value_1.pkb_service[index_2].service_master_code,
                  service_estimate_service_lts:
                    value_1.pkb_service[index_2].service_master_lts,
                  service_estimate_service_price:
                    value_1.pkb_service[index_2].service_category_standard_cost,
                  service_estimate_service_total:
                    parseFloat(
                      value_1.pkb_service[index_2].service_master_lts
                    ) *
                    value_1.pkb_service[index_2].service_category_standard_cost,
                  service_estimate_service_remark:
                    value_1.pkb_service[index_2].pkb_service_remark,
                  no_part: index_2 + 1,
                  service_estimate_part_name: value_2.spare_part_master_name,
                  service_estimate_part_code: value_2.spare_part_master_code,
                  service_estimate_part_price:
                    value_2.spare_part_master_unit_price,
                  service_estimate_part_qty: value_2.pkb_spare_part_qty,
                  service_estimate_part_total:
                    value_2.spkb_spare_part_qty *
                    value_2.spare_part_master_unit_price,
                  service_estimate_part_remark: value_2.pkb_spare_part_remark,
                  created_at: value_1.created_at,
                  updated_at: value_1.updated_at,
                };

                dataReturn.push(data);
              } else {
                // console.log(index_1+", "+value_1.service_estimate_no+" part "+value_2.spare_part_master_name+' - kosong')
                var no = null;
                if (index_2 == 0) {
                  no = index_1 + 1;
                }
                var data = {
                  no: no,
                  pkb_no: value_1.pkb_no,
                  pkb_datetime: value_1.pkb_datetime,
                  pkb_pool: value_1.pkb_service_estimate.pool.pool_name,
                  pkb_status: pkb_status,
                  service_estimate_no:
                    value_1.pkb_service_estimate.service_estimate_no,
                  service_estimate_create_at_datetime:
                    value_1.pkb_service_estimate
                      .service_estimate_create_at_datetime,
                  service_estimate_ppn: service_estimate_ppn,
                  service_estimate_guarantee: service_estimate_guarantee,
                  client_phone: client_phone,
                  client_name: client_name,
                  client_email: client_email,
                  client_address: client_address,
                  vehicle_plate_no: vehicle_plate_no,
                  vehicle_door_no: vehicle_door_no,
                  vehicle_model_car: vehicle_model,
                  vehicle_body_color: vehicle_body_color,
                  vehicle_production_year: vehicle_production_year,
                  vehicle_chasis_no: vehicle_chassis_no,
                  vehicle_engine_no: vehicle_engine_no,
                  vehicle_fuel_type: vehicle_fuel_type,
                  vehicle_km: value_1.pkb_service_estimate.service_estimate_vehicle_km,

                  pkb_spion: value_1.pkb_spion == 1 ? "Yes" : "no",
                  pkb_battery_1: value_1.pkb_battery_1 == 1 ? "Yes" : "no",
                  pkb_battery_2: value_1.pkb_battery_2 == 1 ? "Yes" : "no",
                  pkb_rak_depan: value_1.pkb_rak_depan == 1 ? "Yes" : "no",
                  pkb_rak_belakang: value_1.pkb_rak_belakang == 1 ? "Yes" : "no",

                  
                  pkb_repeat_order: value_1.pkb_repeat_order,
                  pkb_keluhan: keluhan,
                  pkb_analisa: analisa,
                  pkb_catatan: value_1.pkb_catatan,
                  pkb_perintah_kerja: value_1.pkb_perintah_kerja,
                  pkb_teknisi: value_1.pkb_teknisi,
                  pkb_payment_plan: value_1.pkb_payment_plan,
                  pkb_work_order_type: value_1.pkb_work_order_type,
                  no_service: null,
                  service_estimate_service_name: null,
                  service_estimate_service_code: null,
                  service_estimate_service_lts: null,
                  service_estimate_service_price: null,
                  service_estimate_service_total: null,
                  service_estimate_service_remark: null,
                  no_part: index_2 + 1,
                  service_estimate_part_name: value_2.spare_part_master_name,
                  service_estimate_part_code: value_2.spare_part_master_code,
                  service_estimate_part_price:
                    value_2.spare_part_master_unit_price,
                  service_estimate_part_qty: value_2.pkb_spare_part_qty,
                  service_estimate_part_total:
                    value_2.pkb_spare_part_qty *
                    value_2.spare_part_master_unit_price,
                  service_estimate_part_remark: value_2.pkb_spare_part_remark,
                  created_at: value_1.created_at,
                  updated_at: value_1.updated_at,
                };
                dataReturn.push(data);
              }
            });
          }
        } else {
          var data = {
            no: "1",
            pkb_no: value_1.pkb_no,
            pkb_datetime: value_1.pkb_datetime,
                  pkb_pool: value_1.pkb_service_estimate.pool.pool_name,
            pkb_status: pkb_status,
            service_estimate_no:
              value_1.pkb_service_estimate.service_estimate_no,
            service_estimate_create_at_datetime:
              value_1.pkb_service_estimate.service_estimate_create_at_datetime,
            service_estimate_ppn: service_estimate_ppn,
            service_estimate_guarantee: service_estimate_guarantee,
            client_phone: client_phone,
            client_name: client_name,
            client_email: client_email,
            client_address: client_address,
            vehicle_plate_no: vehicle_plate_no,
            vehicle_door_no: vehicle_door_no,
            vehicle_model_car: vehicle_model,
            vehicle_body_color: vehicle_body_color,
            vehicle_production_year: vehicle_production_year,
            vehicle_chasis_no: vehicle_chassis_no,
            vehicle_engine_no: vehicle_engine_no,
            vehicle_fuel_type: vehicle_fuel_type,
            vehicle_km: value_1.pkb_service_estimate.service_estimate_vehicle_km,

            pkb_spion: value_1.pkb_spion == 1 ? "Yes" : "no",
            pkb_battery_1: value_1.pkb_battery_1 == 1 ? "Yes" : "no",
            pkb_battery_2: value_1.pkb_battery_2 == 1 ? "Yes" : "no",
            pkb_rak_depan: value_1.pkb_rak_depan == 1 ? "Yes" : "no",
            pkb_rak_belakang: value_1.pkb_rak_belakang == 1 ? "Yes" : "no",

            
            pkb_repeat_order: value_1.pkb_repeat_order,
            pkb_keluhan: keluhan,
            pkb_analisa: analisa,
            pkb_catatan: value_1.pkb_catatan,
            pkb_perintah_kerja: value_1.pkb_perintah_kerja,
            pkb_teknisi: value_1.pkb_teknisi,
            pkb_payment_plan: value_1.pkb_payment_plan,
            pkb_work_order_type: value_1.pkb_work_order_type,
            no_service: null,
            service_estimate_service_name: null,
            service_estimate_service_code: null,
            service_estimate_service_lts: null,
            service_estimate_service_price: null,
            service_estimate_service_total: null,
            service_estimate_service_remark: null,
            no_part: null,
            service_estimate_part_name: null,
            service_estimate_part_code: null,
            service_estimate_part_price: null,
            service_estimate_part_qty: null,
            service_estimate_part_total: null,
            service_estimate_part_remark: null,
            created_at: value_1.created_at,
            updated_at: value_1.updated_at,
          };

          dataReturn.push(data);
        }
      });
      return dataReturn;
    },
  },
};
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
  font-size: 0.8rem;
}
</style>
